import { render, staticRenderFns } from "./personsetting.vue?vue&type=template&id=e6545db8&scoped=true&"
import script from "./personsetting.vue?vue&type=script&lang=js&"
export * from "./personsetting.vue?vue&type=script&lang=js&"
import style0 from "./personsetting.vue?vue&type=style&index=0&id=e6545db8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6545db8",
  null
  
)

export default component.exports